import React from 'react'

function ResponseDisplayWrapper({ number, prompt, children }) {
    return (
        <div className='my-4'>
            <h2 className='txt-md font-semibold mb-2'>Question {number}</h2>
            <p className=' text-xl font-bold mb-2' >{prompt}</p>
            <div className='px-4'>
                {children}
            </div>
        </div>
    )
}

export default ResponseDisplayWrapper